export type MarketCity =
  | 'VANCOUVER'
  | 'MONTREAL'
  | 'TORONTO'
  | 'LOS ANGELES'
  | 'NEW YORK';

export type MarketConfig = {
  city: MarketCity;
  currency: 'CAD' | 'USD';
  country: 'CA' | 'US';
  freeShippingThreshold: number;
  flatShippingFee: number;
};

export const DEFAULT_MARKET_CITY: MarketCity = 'VANCOUVER';

export const MARKET_CONFIG: Record<MarketCity, MarketConfig> = {
  VANCOUVER: {
    city: 'VANCOUVER',
    currency: 'CAD',
    country: 'CA',
    freeShippingThreshold: 300,
    flatShippingFee: 10,
  },
  MONTREAL: {
    city: 'MONTREAL',
    currency: 'CAD',
    country: 'CA',
    freeShippingThreshold: 300,
    flatShippingFee: 10,
  },
  TORONTO: {
    city: 'TORONTO',
    currency: 'CAD',
    country: 'CA',
    freeShippingThreshold: 300,
    flatShippingFee: 10,
  },
  'LOS ANGELES': {
    city: 'LOS ANGELES',
    currency: 'USD',
    country: 'US',
    freeShippingThreshold: 200,
    flatShippingFee: 10,
  },
  'NEW YORK': {
    city: 'NEW YORK',
    currency: 'USD',
    country: 'US',
    freeShippingThreshold: 200,
    flatShippingFee: 10,
  },
};

export const ACTIVE_MARKET_CITIES: MarketCity[] = ['VANCOUVER'];

export const getSelectedMarket = (): MarketConfig => {
  const storedCity = localStorage.getItem('marketCity') as MarketCity | null;
  return MARKET_CONFIG[storedCity || DEFAULT_MARKET_CITY] ??
    MARKET_CONFIG[DEFAULT_MARKET_CITY];
};

export const setSelectedMarketCity = (city: MarketCity) => {
  localStorage.setItem('marketCity', city);
};

export const calculateMarketShipping = (
  subtotal: number,
  market: MarketConfig
) => (subtotal >= market.freeShippingThreshold ? 0 : market.flatShippingFee);
